export default __webpack_public_path__ + "static/media/README.11d73364.md";